<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Incomplete size conversions</h1>
		<Table class="margin-top" :filters="filters" :columns="columns" :rows="rows" />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    rows: [],
    columns: {
      id: {
        name: 'Variant ID'
      },
      parent_id: {
        name: 'Product ID'
      },
      sku: {},
      size: {},
      qty_stock: {},
      brand_slug: {}
    },
    filters: {
      qty_stock: {
        name: 'Qty.',
        mode: 'number'
      }
    }
  }),
  methods: {
    load () {
      Vue.$api.get('/products/size-conversions/incomplete', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.rows = data.map(row => {
          row.menu = [
            {
              name: 'View product',
              url: '/#/product/' + row.parent_id
            }
          ]

          return row
        })
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
